import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  AppState,
  initialState,
  Student,
  AttendanceState,
  AttendanceSlot,
} from './app_state';
import { AttendancePersistService } from './persist_sevice';

@Injectable({ providedIn: 'root' })
export class YoklamaStateService {
  private KEY = 'courseStartPageData';

  private state: AppState = this.load();
  private subject = new BehaviorSubject<AppState>(this.state);

  state$ = this.subject.asObservable();

  constructor(private persist: AttendancePersistService) {}
  hydrate() {
    const loaded = this.load();
    this.state = loaded;
    this.emit();
  }
  // ================= LOAD =================
  private load(): AppState {
    const data = localStorage.getItem(this.KEY);

    if (!data) return structuredClone(initialState);

    try {
      const parsed = JSON.parse(data);

      // 🔥 STUDENT SOURCE FIX (students vs Ogrenciler)
      const studentsRaw = parsed.students || parsed.Ogrenciler || [];

      // 🔥 TOTAL SLOT FIX
      const totalSlots =
        parsed.totalSessionHours ??
        parsed.attendance?.totalSessionHours ??
        initialState.attendance.totalSessionHours;

      // 🔥 SLOT OLUŞTUR
      const slots: AttendanceSlot[] = Array.from(
        { length: totalSlots },
        (_, i) => ({
          slotNumber: i + 1,
          katildiMi: false,
          konumDisi: false,
          active: false,
          label: `Saat ${i + 1}`,
        }),
      );

      // 🔥 MODE
      const yoklamaPeriyodu = parsed.yoklamaPeriyodu ?? 'saatbasi';

      if (yoklamaPeriyodu === 'teksefer') {
        // ✅ TEKSEFER → tüm slotlar aktif
        slots.forEach((s) => (s.active = true));
      } else {
        // ✅ SAATBAŞI → student attendance'a göre aktif slot
        studentsRaw.forEach((student: any) => {
          (student.attendance || []).forEach((att: any) => {
            const slot = slots.find((s) => s.slotNumber === att.slotNumber);
            if (slot) slot.active = true;
          });
        });
      }


      const attendanceData = parsed.attendance || {};
      return {
        course: {
          ...structuredClone(initialState.course),
          courseId: parsed.courseId ?? 0,
          dersBaslangic: parsed.dersBaslangic
            ? new Date(parsed.dersBaslangic)
            : null,
          dersBitis: parsed.dersBitis ? new Date(parsed.dersBitis) : null,
          haftalikDersId: parsed.haftalikDersId ?? 0,
          courseStartId: parsed.courseStartId ?? 0,
          teacherId: parsed.teacherId ?? '',
          akademikPersonelNo: parsed.akademikPersonelNo ?? 0,
          acilanDersDetayNo: parsed.acilanDersDetayNo ?? 0,
          acilanDersNo: parsed.acilanDersNo ?? 0,
          gun: parsed.gun ?? 0,
          started: parsed.dersbasldimi ?? false,
          dersAd: parsed.dersAd ?? '',
          dersAdres: parsed.dersAdres ?? '',
        },

        attendance: {
          ...structuredClone(initialState.attendance),
          ...attendanceData,
          slotCount: parsed.slotCount ?? 0,

          // 🔥 TOTAL SESSION FIX
          totalSessionHours:
            parsed.totalSessionHours ??
            parsed.attendance?.totalSessionHours ??
            1,

          attendanceDuration: parsed.attendanceDuration ?? 0,
          dersbasldimi: parsed.dersbasldimi ?? false,

          yoklamaPeriyodu,

          // 🔥 STUDENT MAP FIX
          students: studentsRaw.map((x: any) =>
            this.mapApiStudentToState(x, totalSlots),
          ),

          // 🔥 INDEX FIX
          aktifSlotIndex:
            parsed.aktifSlotIndex ?? parsed.attendance?.aktifSlotIndex ?? 0,

          slots: slots,
        },

        ui: {
          ...structuredClone(initialState.ui),

          // 🔥 UI FIX (iki ihtimali de destekle)
          konumKontrol:
            parsed.konumKontrol ?? parsed.konumKontrolAktif ?? false,

          qrUret: parsed.qrUret ?? parsed.qrUretAktif ?? false,
          // 🔥 SON KONUM ÖNCELİKLİ
          latitude:
            parsed.latitude ?? parsed.binaLatitude ?? initialState.ui.latitude,
          longitude:
            parsed.longitude ??
            parsed.binaLongitude ??
            initialState.ui.longitude,

          // bina konumu (istersek ayrıca saklıyoruz)
          binaLatitude: parsed.binaLatitude ?? initialState.ui.binaLatitude,
          binaLongitude: parsed.binaLongitude ?? initialState.ui.binaLongitude,

          kampusLatitude:
            parsed.kampusLatitude ?? initialState.ui.kampusLatitude,
          kampusLongitude:
            parsed.kampusLongitude ?? initialState.ui.kampusLongitude,
        },
      };
    } catch (e) {
      console.error('Load error:', e);
      return structuredClone(initialState);
    }
  }

  syncStudentsFromApi(apiStudents: any[]) {
    if (!apiStudents?.length) return;

    const mapped = apiStudents.map((x) =>
      this.mapApiStudentToState(x, this.state.attendance.totalSessionHours),
    );

    let changed = false;

    const newStudents = [...this.state.attendance.students];

    mapped.forEach((apiStudent) => {
      const index = newStudents.findIndex((s) => s.id === apiStudent.id);

      if (index === -1) return;

      const local = newStudents[index];

      const mergedAttendance = [...(local.attendance || [])];

      apiStudent.attendance.forEach((apiSlot) => {
        const i = mergedAttendance.findIndex(
          (s) => s.slotNumber === apiSlot.slotNumber,
        );

        if (i !== -1) {
          mergedAttendance[i] = { ...mergedAttendance[i], ...apiSlot };
        } else {
          mergedAttendance.push(apiSlot);
        }
      });

      newStudents[index] = {
        ...local,
        ...apiStudent,
        attendance: mergedAttendance,
      };

      changed = true;
    });

    if (changed) {
      this.state.attendance.students = newStudents;
      this.emit();
      this.persist.saveAll(this.state, 'sync ogerenci');
    }
  }
  update(): void {
    this.emit();
  }



  generateSlots(): void {
  const s = this.getState();

  // 🔥 HER ZAMAN TEMİZLE
  this.setSlots([]);

  if (!s.course.dersBaslangic || !s.course.dersBitis) return;

  const start = new Date(s.course.dersBaslangic);
  const end = new Date(s.course.dersBitis);

  const dersSuresi = 50;
  const ara = 10;

  // 🛠️ HESAPLAMA MOTORU (GÜÇLENDİRİLDİ)
  // Milisaniye farklarını ve yuvarlama hatalarını engellemek için Math.round
  const totalMinutes = Math.round((end.getTime() - start.getTime()) / 60000);

  // Akademik slot formülü: Son teneffüsü hayali ekleyip (ders+ara) paketine böl
  const slotCountCalculated = Math.floor((totalMinutes + ara) / (dersSuresi + ara));

  const slots = [];
  let current = new Date(start);

  // 📝 SLOTLARI ÜRET
  for (let i = 0; i < slotCountCalculated; i++) {
    const slotStart = new Date(current);
    const slotEnd = new Date(slotStart.getTime() + dersSuresi * 60000);

    slots.push({
      slotNumber: i + 1,
      label: `${this.format(slotStart)} - ${this.format(slotEnd)}`,
      active: false,
    });

    // Bir sonraki slotun başlangıcı
    current = new Date(slotEnd.getTime() + ara * 60000);
  }

  // 🧠 STATE GÜNCELLEME
  // Hesaplanan slot sayısını hem toplam saat hem de (eğer boşsa) slotCount olarak yaz
  this.setAttendance({
    totalSessionHours: slotCountCalculated,
    slotCount: s.attendance.slotCount ?? 0,
  });

  // 🟢 AKTİF SLOT HESABI (SENİN MANTIĞIN)
  const started = s.course.started;
  const slotCountState = s.attendance.slotCount ?? 0;
  let activeCount = 0;

  if (started === true && slotCountState > 0) {
    // Toplam üretilen slot sayısından, kalan slot sayısını çıkarıyoruz
    activeCount = slots.length - slotCountState;
  } else {
    activeCount = 0;
  }

  // Slotları aktiflik durumuna göre boya
  const updatedSlots = slots.map((slot, index) => ({
    ...slot,
    active: index < activeCount,
  }));

  this.setSlots(updatedSlots);

  // 🎯 UI & PHASE YÖNETİMİ
  let phase: 'idle' | 'running' | 'ended' = 'idle';

  if (started === true && slotCountState > 0) {
    phase = 'running';
  } else if (started === false && slotCountState === 0 && s.course.started !== undefined) {
    // Eğer ders başlamış ve bitmişse (slotCount 0'a inmişse)
    phase = 'ended';
  } else {
    phase = 'idle';
  }

  this.setUi({
    coursePhase: phase,
    currentStep: (phase === 'idle') ? 1 : 2,
  });

  // 💾 KAYDET VE BİTİR
  this.persist.saveAll(this.getState());


}
  private format(date: Date): string {
    return date.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  // ================= SAVE =================
  // SET konum
  setKampusKonum(lat: number, lng: number) {
    this.state.ui.kampusLatitude = lat;
    this.state.ui.kampusLongitude = lng;
    this.emit();
  }

  setBinaKonum(lat: number, lng: number) {
    this.state.ui.binaLatitude = lat;
    this.state.ui.binaLongitude = lng;
    this.state.ui.latitude = lat;
    this.state.ui.longitude = lng;
    this.emit();
  }

  // GET konum
  getKampusKonum() {
    return {
      lat: this.state.ui.kampusLatitude,
      lng: this.state.ui.kampusLongitude,
    };
  }

  getBinaKonum() {
    return {
      lat: this.state.ui.binaLatitude,
      lng: this.state.ui.binaLongitude,
    };
  }
  mapApiStudentToState(api: any, totalSessionHours?: number): Student {
    const state = this.getState();
    const attendanceState = state.attendance || initialState.attendance; // 🔥 safe fallback

    const total = totalSessionHours || attendanceState.totalSessionHours || 1;
    const isSingleShot = attendanceState.yoklamaPeriyodu === 'teksefer';


    // DB'den gelen yoklama listesi
    let attendanceList = (api.attendance || api.yoklama || [])
      .filter((a: any) => a.slotNumber != null && a.slotNumber > 0)
      .map((a: any) => ({
        slotNumber: Number(a.slotNumber),
        katildiMi: !!a.katildiMi,
        konumDisi: !!a.konumDisi,
      }));

    // Tüm slotları oluştur
    let fullList = Array.from({ length: total }, (_, i) => ({
      slotNumber: i + 1,
      katildiMi: false,
      konumDisi: false,
    }));
    attendanceList.forEach((att: any) => {
      const index = att.slotNumber - 1;

      if (index >= 0 && index < fullList.length) {
        fullList[index] = {
          ...fullList[index],
          katildiMi: att.katildiMi,
          konumDisi: att.konumDisi,
        };
      }
    });

    if (isSingleShot && attendanceList.length === 1) {

      const first = attendanceList[0];
      fullList = fullList.map((slot) => ({
        ...slot,
        katildiMi: first.katildiMi,
        konumDisi: first.konumDisi,
      }));
    }

    return {
      id: Number(api.studentId ?? api.id ?? api.Id),
      studentId: Number(api.studentId ?? api.id ?? api.Id),
      adSoyad:
        `${api.studentName ?? api.adSoyad ?? ''} ${api.studentSurName ?? ''}`.trim(),
      ogrenciNo: String(api.ogrenciDersNo ?? api.ogrenciNo ?? ''),
      attendance: fullList,
    };
  }

  private emit() {
    this.subject.next({ ...this.state });
  }

  getState() {
    return this.state;
  }

  // ================= COURSE =================
  startLesson(data: any) {
    this.state.course = { ...this.state.course, ...data };
    this.emit();
    this.persist.saveAll(this.state, 'start lesson 2');
  }

  endLesson() {
    this.state.attendance.dersbasldimi = false;
    this.emit();
    this.persist.saveAll(this.state, 'endlesson');
  }

  // ================= SLOT =================
  setSlots(slots: any[]) {
    this.state.attendance.slots = slots;
    this.emit();
    /*  if(slots.length>=1){
 this.persist.saveAll(this.state);
    } */
  }

  nextSlot() {
    const nextIndex = this.state.attendance.aktifSlotIndex + 1;

    if (nextIndex >= this.state.attendance.slots.length) return;

    this.state.attendance.aktifSlotIndex = nextIndex;

    this.emit();
  }

  // ================= STUDENT =================
  setStudents(students: Student[]) {
    this.state.attendance.students = students;
    this.persist.saveAll(this.state, 'setstudnts');
    this.emit();
  }

  updateStudent(studentId: number, slot: number, data: any) {
    const student = this.state.attendance.students.find(
      (s) => s.id === studentId,
    );
    if (!student) return;

    let slotData = student.attendance.find((x) => x.slotNumber === slot);

    if (!slotData) {
      slotData = {
        slotNumber: slot,
        katildiMi: false,
        konumDisi: false,
      };
      student.attendance.push(slotData);
    }

    Object.assign(slotData, data);

    this.emit();
    this.persist.saveAll(this.state, 'updatestudent');
  }

  setAttendance(att: Partial<AttendanceState>) {
    this.state.attendance = { ...this.state.attendance, ...att };
    this.emit();
    //this.persist.saveAll(this.state,"setattendance");
  }

  // slot active toggle
  toggleSlotActive(index: number, value: boolean) {
    const slot = this.state.attendance.slots[index];
    if (!slot) return;

    slot.active = value;

    this.emit();
  }
  // ================= UI =================
  setUi(ui: any) {
    this.state.ui = { ...this.state.ui, ...ui };
    this.emit();
  }

  // ================= RESET =================
  reset() {
    this.state = structuredClone(initialState);

    this.emit();

    this.persist.clearAll();
  }
}
